interface HeadingLocation {
  suburbName?: string | null;
  state?: string | null;
  postcode?: string | null;
}

const formatResultsHeading = ({
  total,
  isAgency,
  locations,
}: {
  total?: number | null;
  isAgency: boolean;
  locations: readonly (HeadingLocation | null)[];
}): string => {
  const count = total ?? 0;
  const isSingular = count === 1;
  const searchType = isAgency
    ? `agenc${isSingular ? 'y' : 'ies'}`
    : `agent${isSingular ? '' : 's'}`;
  const results = `${count} real estate ${searchType}`;

  const formattedLocations = locations
    .map((location) =>
      [location?.suburbName, location?.state?.toUpperCase(), location?.postcode]
        .filter(Boolean)
        .join(', '),
    )
    .filter(Boolean);

  if (!formattedLocations.length) {
    return results;
  }

  const otherCount = formattedLocations.length - 1;
  const location =
    otherCount === 0
      ? formattedLocations[0]
      : `${formattedLocations[0]} & ${otherCount} other${
          otherCount === 1 ? '' : 's'
        }`;

  return `${results} in ${location}`;
};

export default formatResultsHeading;
